import { FONT } from "@/styles/common";
import theme from "@/styles/theme";
import { css } from "@emotion/react";
import styled from "@emotion/styled";
import { InputProps } from "./input.type";

export const SizeCSS = {
    default: css`
        width: 226px;
        height: 48px;
    `,
    full: css`
        width: 100%;
    `,
    half: css`
        width: 50%;
    `,
};
export const TypeCSS = {
    text: css`
        width: 226px;
        height: 48px;
        padding: 12px 0;
        text-align: center;
        border: none;
        background-color: ${theme.COLOR.gray[100]};
        border-radius: 8px;
        &::placeholder {
            color: ${theme.COLOR.gray[400]};
        }
    `,
    tel: css`
        width: 226px;
        height: 48px;
        padding: 12px 0;
        text-align: center;
        border: none;
        background-color: ${theme.COLOR.gray[100]};
        border-radius: 8px;

        &::placeholder {
            color: ${theme.COLOR.gray[400]};
        }
    `,
    password: css`
        width: 226px;
        height: 48px;
        padding: 12px 0;
        text-align: center;
        border: 1px solid ${theme.COLOR.black};
        background-color: ${theme.COLOR.white};
        border-radius: 8px;

        &::placeholder {
            color: ${theme.COLOR.gray[400]};
        }
    `,
    checkBox: css`
        display: none;
        & + label + label {
            ${FONT("pretendard", 16, 500, 1)};
            color: ${theme.COLOR.black};
        }

        & + label {
            display: inline-block;
            position: relative;
            width: 18px;
            height: 18px;
            cursor: pointer;
            border: 1px solid ${theme.COLOR.gray[500]};
            border-radius: 2px;
        }
        &:checked + albel::after {
            content: "✔";
            font-size: 12px;
            width: 18px;
            height: 18px;
            text-align: center;
            position: absolute;
            left: 50%;
            top: 50%;
            transform: translate(-50%, -50%);
            color: ${theme.COLOR.white};
            background-color: ${theme.COLOR.pink[200]};
            border: 1px solid ${theme.COLOR.pink[200]};
        }
    `,

    radio: css`
        border: 1px solid ${theme.COLOR.gray[400]};
        accent-color: ${theme.COLOR.pink[200]};
    `,
};

export const StyledInput = styled.input<InputProps>`
    ${({ type = "text" }) => TypeCSS[type]}
    ${({ widthSize = "default" }) => SizeCSS[widthSize]};
`;
